import gql from 'graphql-tag';

export const getOrgMembershipsQuery = gql`
  query getOrgMemberships {
    getOrgMemberships {
      membershipId
      userEmail
      status
      role {
        roleId
        name
      }
      user {
        userId
        firstName
        lastName
        permissions {
          permission
        }
      }
      organisation {
        organisationId
        name
        alias
        clientType
        ssoConfig
        preferences
        imageUrl
        permissions
        billingEntityCode
        shutterstockAccess
        orgPackage: package {
          includedAddonTypes
          amendmentsQuantity
          userAllowance
          subEnd
          addonCosts
        }
        organisationProduct {
          organisationProductsId
          organisationId
          trial
          expiryDate
          product {
            productId
            shortName
            longName
          }
        }
      }
    }
  }
`;

const getOrgMemberships = () => ({
  query: getOrgMembershipsQuery,
  module: 'organisations',
  ignoreCache: true,
  buildVariables: () => ({})
});

export default getOrgMemberships;